import { Controller } from '@hotwired/stimulus';

// Takes the page to the first field the server rejected. A 422 replaces the body while the
// viewport stays where the submit button was - the bottom of a long form, nowhere near the
// message saying why nothing happened. The toast says the save failed; this says where.
//
// One controller on <body> rather than a hook per form: `.field-error` is the only error
// markup in the app (FormFieldComponent renders it and the hand-written forms copy it), so
// "the first one on the page" is a question worth asking once.
export default class extends Controller {
  connect() {
    const error = this.element.querySelector('.field-error');
    if (!error) return;

    // Next frame, not now: a <details> opened below is measured wrong until the browser has
    // laid the new body out, and Turbo's own scroll restoration would land on top of us.
    requestAnimationFrame(() => this.reveal(error));
  }

  reveal(error) {
    this.unfold(error);

    const control = this.controlFor(error);
    (control || error).scrollIntoView({ block: 'center', behavior: this.behavior });
    control?.focus({ preventScroll: true });
  }

  // Sections and row cards fold. The server already opens the ones carrying an error, but a
  // field inside a closed <details> has no box to scroll to, so this never assumes it did.
  unfold(error) {
    let details = error.closest('details');

    while (details) {
      details.open = true;
      details = details.parentElement?.closest('details');
    }
  }

  controlFor(error) {
    const field = error.closest('[data-controller~="field-errors"]');

    return field?.querySelector('[data-field-errors-target="input"]');
  }

  get behavior() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  }
}
